export interface TableInitForm {
  remark: string;
  id: number;
  status: string | number;
  expressName: string;
  expressNo: string;
  shipperCode: string;
  expressId: string | number;
  take:string | number | boolean;
}

export const initForm: TableInitForm = {
  remark: "",
  id: 0,
  status: "",
  expressName: "",
  expressNo: "",
  shipperCode: "",
  expressId: "",
  take:false,
};

export const initOptions: Array<{ value: number; label: string }> = [
  {
    value: 7,
    label: "已签收",
  },
  {
    value: 9,
    label: "已完成",
  },
  {
    value: 11,
    label: "已关闭",
  },
  {
    value: 13,
    label: "无效订单",
  },
];